//-------------------------------------------------------------------------------------------------- Imports
import ServicesCard from "./ServicesCard";
import _ from "lodash";
import Loading from "../../../components/Loading";
import { Col, Row } from "antd";
import { StyleSheet } from "../../../StyleSheet";
import { ResponsePackageGroups } from "../../../types/common";
import { useState } from "react";
import InfoCardComponent from "../../../components/InfoCardComponent";

//-------------------------------------------------------------------------------------------------- Interfaces
interface RenderAllServicesCardsProps {
    loading: boolean;
    hasError: boolean;
    services: ResponsePackageGroups[];
};

//-------------------------------------------------------------------------------------------------- Component
const RenderAllServicesCards = (props: RenderAllServicesCardsProps) => {
    const { loading, hasError, services } = props;
    // Control
    const [selected, setSelected] = useState<number | undefined>(undefined);

    const handlePressCard = (key: number) => {
        if (selected === key) {
            setSelected(undefined);
        }
        else {
            setSelected(key);
        }
    };

    return (
        <>
            {
                loading ?
                    <Loading />
                    : !_.isEmpty(services) ?
                        <Row style={styles.cardsRow}>
                            {
                                services.map((obj, key: number) => (
                                    <Col key={key} sm={24} xl={12} xxl={8}>
                                        <ServicesCard
                                            id={key}
                                            service={obj}
                                            selection={selected}
                                            onClick={() => handlePressCard(key)}
                                        />
                                    </Col>
                                ))
                            }
                        </Row>
                        : hasError ?
                            <InfoCardComponent
                                color="#FFC439"
                                colorText="#000"
                                title="¡Estimado usuario!"
                                description={"Ocurrió un error al obtener los servicios. Intente de nuevo más tarde."}
                            />
                            :
                            <InfoCardComponent
                                color="#FFC439"
                                colorText="#000"
                                title="¡Estimado usuario!"
                                description={"No hay servicios para mostrar."}
                            />
            }
        </>
    );
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    cardsRow: {
        display: "flex",
        width: "100%",
        justifyContent: "flex-start",
    }
});

//-------------------------------------------------------------------------------------------------- Exports
export default RenderAllServicesCards;
